(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-reviews"] && !Shopify.designMode) return;
  try {
    
  window.mrToggleVideo = function(card){
    const v = card.querySelector('video');
    if (!v) return;
    if (card.classList.contains('playing')) {
      v.pause(); card.classList.remove('playing');
    } else {
      document.querySelectorAll('.mr-card.playing').forEach(c => {
        c.querySelector('video').pause(); c.classList.remove('playing');
      });
      card.classList.add('loading');
      v.preload = 'auto';
      v.addEventListener('canplay', () => {
        card.classList.remove('loading');
        card.classList.add('playing');
        v.play();
      }, { once: true });
      if (v.readyState >= 3) {
        card.classList.remove('loading');
        card.classList.add('playing');
        v.play();
      } else {
        v.load();
      }
    }
  };

  } catch(e) { console.error(e); }
})();
})();
